/**
 *  update by tannc 2018年12月24日20:33:50
 */

import {
  STATISTICS_INVOKE_ALL_API,
  STATISTICS_INVOKE_COMMON_API,
  STATISTICS_INVOKE_QUESTION_API,
  STATISTICS_INVOKE_QUESTION_V4_API,
  STATISTICS_INVOKE_DOCUMENT_API,
  STATISTICS_INVOKE_DETAIL_API,
  STATISTICS_INVOKE_QUESTION_V4_DETAIL_API,
  STATISTICS_INVOKE_DISTINCT_API,
  STATISTICS_INVOKE_QUESTION_V4_DISTINCT_API,
  STATISTICS_INVOKE_DOWNLOAD_API,
  STATISTICS_INVOKE_DOWNLOAD_DISTINCT_API,
  INTERFACE_STATISTICS_API,
  INTERFACE_STATISTICS_DETAIL_API,
  DEVELOPER_STATISTICS_DETAIL_API,
  STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_DISTINCT_API,
  STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_API,
  STATISTICS_INVOKE_ELITESCHOOL_API,
  STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_DISTINCT_API,
  STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_API,
  STATISTICS_INVOKE_MICROCLASS_API,
  STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_DISTINCT_API,
  STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_API,
  STATISTICS_INVOKE_SHIJUAN_API,
  STATISTICS_INVOKE_ALBUM_DOWNLOAD_DISTINCT_API,
  STATISTICS_INVOKE_ALBUM_DOWNLOAD_API,
  STATISTICS_INVOKE_ALBUM_API
} from '../resource/index'
import axios from '../config/axios.config'
export default {

  // 全部接口
  async fetchAllData (params) {
    return await axios.get(STATISTICS_INVOKE_ALL_API, params)
  },
  // 公共接口
  async fetchCommonData (params) {
    return await axios.get(STATISTICS_INVOKE_COMMON_API, params)
  },
  // 试题调用
  async fetchQuestionData (params) {
    return await axios.get(STATISTICS_INVOKE_QUESTION_API, params)
  },
  async fetchQuestionV4Data (params) {
    return await axios.get(STATISTICS_INVOKE_QUESTION_V4_API, params)
  },
  // 文档调用
  async fetchDocData (params) {
    return await axios.get(STATISTICS_INVOKE_DOCUMENT_API, params)
  },
  // 文档资源类接口
  async fetchDetailData (params) {
    return await axios.get(STATISTICS_INVOKE_DETAIL_API, params)
  },
  async fetchQuestionV4DetailData (params) {
    return await axios.get(STATISTICS_INVOKE_QUESTION_V4_DETAIL_API, params)
  },
  async fetchDistinctData (params) {
    return await axios.get(STATISTICS_INVOKE_DISTINCT_API, params)
  },
  async fetchQuestionV4DistinctData (params) {
    return await axios.get(STATISTICS_INVOKE_QUESTION_V4_DISTINCT_API, params)
  },
  async fetchDownloadData (params) {
    return await axios.get(STATISTICS_INVOKE_DOWNLOAD_API, params)
  },
  async fetchDownloadDistinctData (params) {
    return await axios.get(STATISTICS_INVOKE_DOWNLOAD_DISTINCT_API, params)
  },
  async fetchInterfaceData () {
    return await axios.get(INTERFACE_STATISTICS_API, {})
  },
  async fetchInterfaceDetailData (params) {
    return await axios.get(INTERFACE_STATISTICS_DETAIL_API, params)
  },
  async fetchDevDetailData (params) {
    return await axios.get(DEVELOPER_STATISTICS_DETAIL_API, params)
  },
  // 名校文档下载去重下载接口调用
  async fetchEliteSchoolDistinctData (params) {
    return axios.get(STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_DISTINCT_API, params)
  },
  // 名校文档下载接口调用统计
  async fetchEliteSchoolData (params) {
    return axios.get(STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_API, params)
  },
  // 名校文档接口统计
  async fetchEliteSchoolDOCData (params) {
    return axios.get(STATISTICS_INVOKE_ELITESCHOOL_API, params)
  },
  // 微课文档下载去重下载接口调用
  async fetchMicroClassDistinctData (params) {
    return axios.get(STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_DISTINCT_API, params)
  },
  // 微课文档下载接口调用统计
  async fetchMicroClassData (params) {
    return axios.get(STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_API, params)
  },
  // 微课文档接口统计
  async fetchMicroClassDOCData (params) {
    return axios.get(STATISTICS_INVOKE_MICROCLASS_API, params)
  },
  // 试卷文档下载去重下载接口调用
  async fetchShijuanDistinctDOCData (params) {
    return axios.get(STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_DISTINCT_API, params)
  },
  // 试卷文档下载接口调用统计
  async fetchShijuanDOCData (params) {
    return axios.get(STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_API, params)
  },
  // 试卷文档接口统计
  async fetchShijuanAPIData (params) {
    return axios.get(STATISTICS_INVOKE_SHIJUAN_API, params)
  },
  // 专辑资源
  async fetchAlbumDistinctDOCData (params) {
    return axios.get(STATISTICS_INVOKE_ALBUM_DOWNLOAD_DISTINCT_API, params)
  },
  // 试卷文档下载接口调用统计
  async fetchAlbumDOCData (params) {
    return axios.get(STATISTICS_INVOKE_ALBUM_DOWNLOAD_API, params)
  },
  // 试卷文档接口统计
  async fetchAlbumAPIData (params) {
    return axios.get(STATISTICS_INVOKE_ALBUM_API, params)
  },
}



// WEBPACK FOOTER //
// ./src/service/statisticsService.js